import { AnimatePresence } from 'framer-motion'
import { useDonations } from '../../hooks/useDonations'
import DonationCard from './DonationCard'

const DonationFeed = () => {
  const { donations, isLoading, isFetchingNextPage, sentinelRef } = useDonations()

  if (isLoading) {
    return (
      <div className="flex flex-col gap-3 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="bg-white rounded-2xl h-24 animate-pulse border border-gray-100" />
          ))}
        </div>
      </div>
    )
  }

  if (!donations.length) {
    return (
      <div className="text-center py-12 text-[#6b7280] font-[FbAsli]">
        <p className="text-xl">היו הראשונים לתרום!</p>
        <p className="text-sm mt-1">בחרו סכום למעלה ותהיו חלק מהחלום של לאה'לע</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="grid grid-cols-1 gap-4 h-full overflow-y-auto">
        <AnimatePresence initial={false}>
          {donations.map((donation) => (
            <DonationCard key={donation.id} donation={donation} />
          ))}
        </AnimatePresence>
      </div>

      {/* Infinite scroll sentinel */}
      <div ref={sentinelRef} className="h-4" />

      {isFetchingNextPage && (
        <div className="flex justify-center py-4">
          <div className="w-6 h-6 border-2 border-[#1a6fad] border-t-transparent rounded-full animate-spin" />
        </div>
      )}

    </div>
  )
}

export default DonationFeed
